export default __webpack_public_path__ + "media/images/icons/arrow-prev-ddc0812959f8ebc4f55cb27a44daa055.svg";